import React, {useState} from 'react';
import BaseModal from "./BaseModal";

function SortingModal(props) {

    const [sortingOption, setSortingOption] = useState('desc');
    const [sortingColumnName, setSortingColumnName ] = useState(null);


    function createColumnNames(){
        let data = [];
        for (let propertyName of Object.keys(props.answer)){
            data.push
            (<li
                key={propertyName}
                className={sortingColumnName === propertyName ? "modal-content__list--selected" : ""}
                id={propertyName}
                onClick={() => setSortingColumnName(propertyName)}>
                {propertyName}
            </li>);
        }
        return data;
    }

    return props.modalShown ?
        (
            <BaseModal modalId={"myModal"} modalClass={"modal"}>
                <div className="modal-content modal-content--sorting">
                    <span className="close" onClick={() => props.closeModal()}>&times;</span>
                    <div className="modal-content__subTitle">Sort</div>
                    <ul className="modal-content__list" data-list='order'>
                        <li onClick={() => setSortingOption('desc')} className={sortingOption === 'desc' ? "modal-content__list--selected" : ""}>Descending</li>
                        <li onClick={() => setSortingOption('asc')}  className={sortingOption === 'asc' ? "modal-content__list--selected" : ""}>Ascending</li>
                    </ul>
                    {props.answer &&
                    <React.Fragment>
                    <div className="modal-content__divider"></div>
                        <div className="modal-content__subTitle">Sort by</div>
                        <ul className="modal-content__list" data-list='by'>
                            {createColumnNames()}
                        </ul>
                    </React.Fragment>}
                    <div className="modal-content__actions pb-md">
                        <a href="javascript:;" className="
                  modal-content__actions__btn
                  modal-content__actions__btn--filledBlue
                  modal-content__actions__btn--fullWidth
                  " onClick={() => props.applySorting({
                            option: sortingOption, sortingColumn: sortingColumnName
                        })}>Apply</a>
                    </div>
                </div>
            </BaseModal>
        ) : null;
}

export default SortingModal;